module.exports = __webpack_public_path__ + "img/default.9fcc3f1.svg";